<template>
  <v-container fluid>
    <!-- KPIs Dashboard -->
    <v-row class="mb-4">
      <v-col cols="12" sm="6" md="3" xl="2">
        <v-card
          class="mx-1 kpi-card"
          elevation="2"
          :style="{ borderTop: '4px solid #4CAF50' }"
        >
          <v-card-text class="text-center py-4">
            <div class="text-overline mb-1">Total Facturas</div>
            <div class="text-h5 font-weight-bold mb-2">
              {{ kpiData.invoice_count || 0 }}
            </div>
            <div class="text-body-2">
              <span :class="kpiData.invoice_trend >= 0 ? 'success--text' : 'error--text'">
                <v-icon small :color="kpiData.invoice_trend >= 0 ? 'success' : 'error'">
                  {{ kpiData.invoice_trend >= 0 ? "mdi-arrow-up" : "mdi-arrow-down" }}
                </v-icon>
                {{ Math.abs(kpiData.invoice_trend || 0) }}%
              </span>
              respecto al periodo anterior
            </div>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" sm="6" md="3" xl="2">
        <v-card
          class="mx-1 kpi-card"
          elevation="2"
          :style="{ borderTop: '4px solid #FFC107' }"
        >
          <v-card-text class="text-center py-4">
            <div class="text-overline mb-1">Notas de Crédito</div>
            <div class="text-h5 font-weight-bold mb-2">
              {{ kpiData.nc_count || 0 }}
            </div>
            <div class="text-body-2">
              <span :class="kpiData.nc_trend <= 0 ? 'success--text' : 'error--text'">
                <v-icon small :color="kpiData.nc_trend <= 0 ? 'success' : 'error'">
                  {{ kpiData.nc_trend >= 0 ? "mdi-arrow-up" : "mdi-arrow-down" }}
                </v-icon>
                {{ Math.abs(kpiData.nc_trend || 0) }}%
              </span>
              respecto al periodo anterior
            </div>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" sm="6" md="3" xl="2">
        <v-card
          class="mx-1 kpi-card"
          elevation="2"
          :style="{ borderTop: '4px solid #2196F3' }"
        >
          <v-card-text class="text-center py-4">
            <div class="text-overline mb-1">Valor Total</div>
            <div class="text-h5 font-weight-bold mb-2">
              {{ formatCurrency(kpiData.total_value || 0) }}
            </div>
            <div class="text-body-2">
              <span :class="kpiData.value_trend >= 0 ? 'success--text' : 'error--text'">
                <v-icon small :color="kpiData.value_trend >= 0 ? 'success' : 'error'">
                  {{ kpiData.value_trend >= 0 ? "mdi-arrow-up" : "mdi-arrow-down" }}
                </v-icon>
                {{ Math.abs(kpiData.value_trend || 0) }}%
              </span>
              respecto al periodo anterior
            </div>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" sm="6" md="3" xl="2">
        <v-card
          class="mx-1 kpi-card"
          elevation="2"
          :style="{ borderTop: '4px solid #9C27B0' }"
        >
          <v-card-text class="text-center py-4">
            <div class="text-overline mb-1">% Con CUFE</div>
            <div class="text-h5 font-weight-bold mb-2">
              {{ kpiData.cufe_percentage || 0 }}%
            </div>
            <div class="text-body-2">
              <span :class="kpiData.cufe_trend >= 0 ? 'success--text' : 'error--text'">
                <v-icon small :color="kpiData.cufe_trend >= 0 ? 'success' : 'error'">
                  {{ kpiData.cufe_trend >= 0 ? "mdi-arrow-up" : "mdi-arrow-down" }}
                </v-icon>
                {{ Math.abs(kpiData.cufe_trend || 0) }}%
              </span>
              respecto al periodo anterior
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-card class="mb-6" elevation="2">
      <v-card-title class="primary white--text py-3 px-4">
        <v-icon color="white" class="mr-2">mdi-filter</v-icon>
        <span>Filtros</span>
        <v-spacer></v-spacer>
        <v-btn
          small
          text
          icon
          color="white"
          @click.stop="showFilterPanel = !showFilterPanel"
        >
          <v-icon>{{ showFilterPanel ? "mdi-chevron-up" : "mdi-chevron-down" }}</v-icon>
        </v-btn>
      </v-card-title>

      <v-expand-transition>
        <div v-if="showFilterPanel">
          <v-card-text class="py-4">
            <v-row>
              <v-col cols="12" sm="6" md="3">
                <v-menu
                  v-model="menuFrom"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="issueDateFrom"
                      label="Desde"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      outlined
                      dense
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="issueDateFrom"
                    @input="menuFrom = false"
                    no-title
                    scrollable
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <v-menu
                  v-model="menuTo"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="issueDate"
                      label="Hasta"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      outlined
                      dense
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="issueDate"
                    @input="menuTo = false"
                    no-title
                    scrollable
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" md="6">
                <v-select
                  v-model="selectedDocTypes"
                  :items="docTypes"
                  label="Tipo de Documento"
                  prepend-icon="mdi-file-document-multiple"
                  outlined
                  dense
                  multiple
                ></v-select>
              </v-col>

              <v-col cols="12" class="text-right">
                <v-btn color="error" outlined class="mr-2" @click.stop="resetFilters">
                  <v-icon left>mdi-refresh</v-icon>
                  Reiniciar
                </v-btn>
                <v-btn color="primary" @click.stop="get_notes">
                  <v-icon left>mdi-magnify</v-icon>
                  Buscar
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </div>
      </v-expand-transition>
    </v-card>

    <!-- Vista de escritorio -->
    <v-card class="mb-6" elevation="2">
      <v-card-title class="primary white--text py-3 px-4">
        <v-icon color="white" class="mr-2">mdi-file-document-multiple</v-icon>
        <span>Documentos</span>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Buscar"
          single-line
          hide-details
          class="mx-2"
          dark
          dense
          style="max-width: 300px"
        ></v-text-field>
        <v-btn
          color="white"
          icon
          small
          class="ml-2"
          @click.stop="exportToCsv"
          title="Exportar a CSV"
        >
          <v-icon>mdi-file-export</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="pa-0">
        <!-- Vista de escritorio para pantallas md y mayores -->
        <div class="d-none d-md-block">
          <v-data-table
            :headers="headers"
            :items="credit_notes"
            :items-per-page="10"
            :search="search"
            sort-by="issuedate"
            :sort-desc="true"
            class="elevation-0"
            dense
            :loading="loading_status"
            loader-height="10"
            loading-text="Cargando..."
            @click:row="get_e_doc"
            :class="{ 'cursor-pointer': !loading_status }"
          >
            <!-- Mantener los templates existentes -->
            <template v-slot:[`item.doc_type`]="{ item }">
              <v-chip x-small :color="getDocTypeColor(item.doc_type)" text-color="white">
                {{ getDocTypeLabel(item.doc_type) }}
              </v-chip>
            </template>

            <template v-slot:[`item.doc_value`]="{ item }">
              <span :class="item.doc_type === 'NC' ? 'error--text' : ''">
                {{ formatCurrency(item.doc_value) }}
              </span>
            </template>

            <template v-slot:[`item.cufe`]="{ item }">
              <v-icon
                small
                :color="item.cufe ? 'success' : 'grey'"
                @click.stop="item.cufe ? openPopup(item.cufe) : null"
                :style="item.cufe ? 'cursor: pointer' : ''"
              >
                {{ item.cufe ? "mdi-check-circle" : "mdi-cancel" }}
              </v-icon>
            </template>

            <template v-slot:[`item.cufe_n`]="{ item }">
              <v-icon
                small
                :color="item.cufe_n ? 'red' : 'grey'"
                @click.stop="item.cufe_n ? openPopup(item.cufe_n) : null"
                :style="item.cufe_n ? 'cursor: pointer' : ''"
              >
                {{ item.cufe_n ? "mdi-check-circle" : "mdi-cancel" }}
              </v-icon>
            </template>
          </v-data-table>
        </div>

        <!-- Vista móvil solo para xs y sm -->
        <div class="d-md-none">
          <v-list two-line>
            <template v-if="!loading_status && credit_notes.length > 0">
              <v-list-item
                v-for="item in credit_notes"
                :key="item.id"
                @click="get_e_doc(item)"
                class="mb-2"
              >
                <v-list-item-content>
                  <v-list-item-title class="d-flex align-center">
                    <v-chip
                      x-small
                      :color="getDocTypeColor(item.doc_type)"
                      text-color="white"
                      class="mr-2"
                    >
                      {{ getDocTypeLabel(item.doc_type) }}
                    </v-chip>
                    <span class="font-weight-medium">{{ item.doc_number }}</span>
                  </v-list-item-title>

                  <v-list-item-subtitle>
                    <div class="d-flex flex-column">
                      <span class="mb-1">
                        <v-icon x-small class="mr-1">mdi-calendar</v-icon>
                        {{ formatDate(item.issuedate) }}
                      </span>
                      <span class="mb-1">
                        <v-icon x-small class="mr-1">mdi-account</v-icon>
                        {{ item.PartyName }}
                      </span>
                      <span>
                        <v-icon x-small class="mr-1">mdi-identifier</v-icon>
                        {{ item.PartyIdentification }}
                      </span>
                    </div>
                  </v-list-item-subtitle>

                  <div class="d-flex align-center mt-2">
                    <div class="mr-4">
                      <v-icon
                        x-small
                        :color="item.cufe ? 'success' : 'grey'"
                        @click.stop="item.cufe ? openPopup(item.cufe) : null"
                      >
                        {{ item.cufe ? "mdi-check-circle" : "mdi-cancel" }}
                      </v-icon>
                      <span class="caption ml-1">CUFE</span>
                    </div>
                    <div>
                      <v-icon
                        x-small
                        :color="item.cufe_n ? 'red' : 'grey'"
                        @click.stop="item.cufe_n ? openPopup(item.cufe_n) : null"
                      >
                        {{ item.cufe_n ? "mdi-check-circle" : "mdi-cancel" }}
                      </v-icon>
                      <span class="caption ml-1">NC</span>
                    </div>
                  </div>
                </v-list-item-content>

                <v-list-item-action>
                  <span
                    :class="[
                      'font-weight-medium',
                      item.doc_type === 'NC' ? 'error--text' : '',
                    ]"
                  >
                    {{ formatCurrency(item.doc_value) }}
                  </span>
                </v-list-item-action>
              </v-list-item>
            </template>

            <!-- Estado de carga -->
            <v-list-item v-if="loading_status">
              <v-list-item-content class="text-center py-5">
                <v-progress-circular
                  indeterminate
                  color="primary"
                  class="mb-2"
                ></v-progress-circular>
                <div class="caption">Cargando documentos...</div>
              </v-list-item-content>
            </v-list-item>

            <!-- Estado vacío -->
            <v-list-item v-if="!loading_status && credit_notes.length === 0">
              <v-list-item-content class="text-center py-5">
                <v-icon large color="grey lighten-1">mdi-file-document-outline</v-icon>
                <div class="caption grey--text mt-2">No hay documentos disponibles</div>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </div>
      </v-card-text>
    </v-card>

    <!-- Mantener el noteViewer -->
    <noteViewer
      :item="item"
      :dialog="dialog"
      @close="dialog = !dialog"
      @refresh="refresh()"
    />
    <v-snackbar
      v-model="snackbar.show"
      :color="snackbar.color"
      :timeout="snackbar.timeout"
      top
    >
      {{ snackbar.text }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbar.show = false"> Cerrar </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import { webserver, getToday } from "../services/webserver.js";
import noteViewer from "../components/doc_viewer.vue";

export default {
  components: { noteViewer },
  data() {
    return {
      search: "",
      snackbar: {
        show: false,
        text: "",
        color: "info",
        timeout: 3000,
      },
      showFilterPanel: false,
      menuFrom: false,
      menuTo: false,
      issueDateFrom: getToday(), // Inicializar con el primer día del mes actual
      selectedDocTypes: ["invoice"],
      docTypes: [
        { text: "Factura", value: "invoice" },
        { text: "Factura Contingencia", value: "invoiceC" },
        { text: "Nota Crédito", value: "NC" },
      ],
      kpiData: {
        invoice_count: 0,
        nc_count: 0,
        total_value: 0,
        cufe_percentage: 0,
        invoice_trend: 0,
        nc_trend: 0,
        value_trend: 0,
        cufe_trend: 0,
      },
      message: "",
      errors: [],
      valid: false,
      loading_status: false,
      f_required: [(v) => !!v || "Requerido"],
      f_email: [
        (v) => !!v || "Correo valido",
        (v) => /.+@.+/.test(v) || "Correo no valido",
      ],
      imageUrl: null,
      dialog: false,
      headers: [
        {
          text: "Tipo",
          align: "center",
          sortable: true,
          value: "doc_type",
          width: "100px",
        },
        {
          text: "Fecha",
          align: "start",
          sortable: true,
          value: "issuedate",
        },
        {
          text: "Documento",
          align: "start",
          sortable: true,
          value: "doc_number",
        },
        {
          text: "CC/NIT/RUT",
          align: "start",
          sortable: true,
          value: "PartyIdentification",
        },
        {
          text: "Cliente",
          align: "start",
          sortable: true,
          value: "PartyName",
        },
        {
          text: "Factura",
          align: "start",
          sortable: true,
          value: "invoice",
        },
        {
          text: "Valor",
          align: "end",
          sortable: true,
          value: "doc_value",
        },
        {
          text: "CUFE",
          align: "center",
          sortable: true,
          value: "cufe",
          width: "80px",
        },
        {
          text: "NC",
          align: "center",
          sortable: true,
          value: "cufe_n",
          width: "80px",
        },
      ],
      credit_notes: [],
      item: { document: null, items: [], payments: [] },
      issueDate: getToday(),
    };
  },
  mounted() {
    //const today = new Date();
    // const firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
    // this.issueDateFrom = firstDay.toISOString().split("T")[0];
    this.issueDateFrom = getToday();
    this.issueDate = getToday();
    this.get_notes();
  },
  methods: {
    exportToCsv() {
      if (!this.credit_notes || this.credit_notes.length === 0) {
        this.showMessage("No hay datos para exportar", "warning");
        return;
      }

      // ... (implementación del método exportToCsv) ...
    },
    openPopup(cufe) {
      if (!cufe) return;
      const url = `https://catalogo-vpfe.dian.gov.co/document/searchqr?documentkey=${cufe}`;
      window.open(url, "_blank", "width=600,height=400,scrollbars=yes,resizable=yes");
    },
    getDocTypeColor(docType) {
      switch (docType?.toLowerCase()) {
        case "invoice":
          return "success";
        case "invoicec":
          return "orange";
        case "nc":
          return "warning";
        default:
          return "grey";
      }
    },

    // Método para obtener la etiqueta del tipo de documento
    getDocTypeLabel(docType) {
      switch (docType?.toLowerCase()) {
        case "invoice":
          return "Factura";
        case "invoicec":
          return "Fact. Contingencia";
        case "nc":
          return "NC";
        default:
          return docType;
      }
    },
    formatDate(dateString) {
      if (!dateString) return "";
      // Extraer solo la fecha sin la hora
      return dateString.split(" ")[0];
    },
    formatCurrency(value) {
      if (!value && value !== 0) return "";
      return new Intl.NumberFormat("es-CO", {
        style: "currency",
        currency: "COP",
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      }).format(value);
    },

    refresh() {
      this.get_notes();
    },
    resetFilters() {
      // Inicializar con fecha del mes actual
      const today = new Date();
      const firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
      this.issueDateFrom = firstDay.toISOString().split("T")[0];
      this.issueDate = getToday();
      this.selectedDocTypes = ["invoice", "invoiceC", "NC"];
      this.search = "";
      this.get_notes();
    },
    async get_notes() {
      this.loading_status = true;
      this.message = "Calculando estadísticas...";

      try {
        let currentData;
        let previousData;

        if (this.issueDateFrom && this.issueDate) {
          // Consulta para el rango de fechas seleccionado
          currentData = await this.fetchDocuments();

          // Calcular el período anterior con la misma duración
          const currentFrom = new Date(this.issueDateFrom);
          const currentTo = new Date(this.issueDate);
          const daysDiff =
            Math.floor((currentTo - currentFrom) / (1000 * 60 * 60 * 24)) + 1;

          const previousTo = new Date(currentFrom);
          previousTo.setDate(previousTo.getDate() - 1);

          const previousFrom = new Date(previousTo);
          previousFrom.setDate(previousFrom.getDate() - daysDiff + 1);

          // Guardar fechas actuales
          const currentIssueDateFrom = this.issueDateFrom;
          const currentIssueDate = this.issueDate;

          // Establecer fechas para consulta anterior
          this.issueDateFrom = previousFrom.toISOString().split("T")[0];
          this.issueDate = previousTo.toISOString().split("T")[0];

          // Consultar período anterior
          previousData = await this.fetchDocuments();

          // Restaurar fechas actuales
          this.issueDateFrom = currentIssueDateFrom;
          this.issueDate = currentIssueDate;
        } else {
          // Si no hay rango de fechas, usar la fecha actual
          currentData = await this.fetchDocuments(this.issueDate);

          const previousDate = new Date(this.issueDate);
          previousDate.setDate(previousDate.getDate() - 1);
          previousData = await this.fetchDocuments(
            previousDate.toISOString().split("T")[0]
          );
        }

        // Calcular KPIs y actualizar tabla
        this.calculateKPIs(currentData, previousData);
        this.credit_notes = currentData;
      } catch (error) {
        console.error("Error en get_notes:", error);
        this.showMessage("Error al cargar los datos: " + error.message, "error");
      } finally {
        this.loading_status = false;
      }
    },
    async fetchDocuments(date) {
      return new Promise((resolve, reject) => {
        const docTypesFilter =
          this.selectedDocTypes.length > 0
            ? this.selectedDocTypes.map((type) => `'${type}'`).join(",")
            : "'invoice','invoiceC','NC'";

        const qry = {
          store: window.store.store_id,
          table: "docs",
          filters: [
            {
              field: "doc_type",
              operator: " IN ",
              value: `${docTypesFilter}`, // Agregar paréntesis aquí
            },
          ],
        };

        // Modificar la lógica de fechas
        if (date) {
          // Para cálculos de KPI (período actual y anterior)
          qry.filters.push({
            field: "DATE(issuedate)",
            operator: "=",
            value: date,
          });
        } else {
          // Para búsqueda por rango de fechas
          const dateFrom = new Date(this.issueDateFrom);
          const dateTo = new Date(this.issueDate);

          // Asegurarse de que las fechas sean válidas
          if (isNaN(dateFrom.getTime()) || isNaN(dateTo.getTime())) {
            reject(new Error("Fechas inválidas"));
            return;
          }

          // Formatear fechas a YYYY-MM-DD
          const formatDate = (date) => {
            return date.toISOString().split("T")[0];
          };

          qry.filters.push(
            {
              field: "DATE(issuedate)",
              operator: ">=",
              value: formatDate(dateFrom),
            },
            {
              field: "DATE(issuedate)",
              operator: "<=",
              value: formatDate(dateTo),
            }
          );
        }

        // Agregar filtro de tienda
        qry.filters.push({
          field: "store",
          operator: "=",
          value: window.store.store_id,
        });

        // Agregar filtro de usuario si es necesario
        if (this.$store.getters.profile.user_access == "USUARIO") {
          qry.filters.push({
            field: "userId",
            operator: "=",
            value: this.$store.state.profile.email,
          });
        }

        console.log("Consulta: =>>>", qry);

        webserver(
          "get_dataTable",
          qry,
          (data) => {
            console.log("Respuesta del servidor:", data);
            resolve(data || []);
          },
          (error) => {
            console.error("Error en la consulta:", error);
            reject(error);
          }
        );
      });
    },
    calculateKPIs(currentData, previousData) {
      // Asegurarse de que los datos no sean null
      currentData = currentData || [];
      previousData = previousData || [];

      console.log("Calculando KPIs con:", { currentData, previousData });

      // Función auxiliar para calcular tendencias
      const calculateTrend = (current, previous) => {
        if (previous === 0) return 0;
        return Math.round(((current - previous) / previous) * 100);
      };

      // Calcular métricas del período actual
      const currentMetrics = {
        invoice_count: currentData.length,
        nc_count: currentData.filter((doc) => doc.doc_type === "NC").length,
        total_value: currentData.reduce(
          (sum, doc) => sum + (parseFloat(doc.doc_value) || 0),
          0
        ),
        with_cufe_count: currentData.filter((doc) => doc.cufe).length,
        total_count: currentData.length,
      };

      // Calcular métricas del período anterior
      const previousMetrics = {
        invoice_count: previousData.length,
        nc_count: previousData.filter((doc) => doc.doc_type === "NC").length,
        total_value: previousData.reduce(
          (sum, doc) => sum + (parseFloat(doc.doc_value) || 0),
          0
        ),
        with_cufe_count: previousData.filter((doc) => doc.cufe).length,
        total_count: previousData.length,
      };

      console.log("Métricas calculadas:", { currentMetrics, previousMetrics });

      // Calcular porcentaje de CUFE
      const currentCufePercentage =
        currentMetrics.total_count === 0
          ? 0
          : Math.round(
              (currentMetrics.with_cufe_count / currentMetrics.total_count) * 100
            );

      const previousCufePercentage =
        previousMetrics.total_count === 0
          ? 0
          : Math.round(
              (previousMetrics.with_cufe_count / previousMetrics.total_count) * 100
            );

      // Actualizar los KPIs
      this.kpiData = {
        invoice_count: currentMetrics.invoice_count,
        nc_count: currentMetrics.nc_count,
        total_value: currentMetrics.total_value,
        cufe_percentage: currentCufePercentage,
        invoice_trend: calculateTrend(
          currentMetrics.invoice_count,
          previousMetrics.invoice_count
        ),
        nc_trend: calculateTrend(currentMetrics.nc_count, previousMetrics.nc_count),
        value_trend: calculateTrend(
          currentMetrics.total_value,
          previousMetrics.total_value
        ),
        cufe_trend: currentCufePercentage - previousCufePercentage,
      };

      console.log("KPIs actualizados:", this.kpiData);
    },

    // Nuevo método para mostrar mensajes
    showMessage(text, color = "info", timeout = 3000) {
      this.snackbar = {
        show: true,
        text,
        color,
        timeout,
      };
    },
    get_e_doc(e) {
      var issudate = e.issuedate.split(" ");
      console.log(issudate[0]);
      var doc = {
        store: e.store,
        issueDate: issudate[0],
        did: e.doc_number,
      };
      console.log(doc);
      webserver("get_invoice_fe", doc, (data) => {
        console.log(data);
        this.item = data;
        this.dialog = true;
        // data.doc.doc_type = "Invoice";
        this.loading_vendors = false;
      });
    },
  },
};
</script>

<style>
/* Agregar los estilos del segundo archivo */
.v-data-table >>> .v-data-table__wrapper {
  overflow-x: auto;
}

.v-data-table >>> th {
  background-color: #f5f5f5 !important;
  font-weight: bold !important;
  white-space: nowrap;
}

.v-data-table >>> tbody tr:nth-of-type(odd) {
  background-color: rgba(0, 0, 0, 0.02);
}

.v-data-table >>> tbody tr:hover {
  background-color: rgba(0, 0, 0, 0.04) !important;
}

.kpi-card {
  transition: all 0.3s;
}

.kpi-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15) !important;
}

.primary {
  background-color: #1976d2 !important;
}

.v-card-title.primary {
  border-radius: 4px 4px 0 0;
}

/* Mantener los estilos existentes */
.cursor-pointer {
  cursor: pointer;
}

/* Mejoras de responsividad */
@media (max-width: 600px) {
  .kpi-card {
    margin-bottom: 16px;
  }

  .v-card-title {
    flex-wrap: wrap;
  }

  .v-data-table >>> th {
    font-size: 0.8rem !important;
  }
}
</style>
